import React from "react";
import styles from "./Section.css";
import { Panel, Button, Row, Col } from "react-bootstrap";
import { getStrValue, isA, isReporter } from "../../store/utility";

class Section extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data: this.props.data,
      originalData: this.props.data,
      address: this.props.data.address ? this.props.data.address : {},
      editing: false,
      label: {
        value: this.getPropValue(["data", "label"]),
        defaultValue: "Nom du site",
        displayDefault: this.getPropValue(["data", "label"]).length === 0,
      },
      addressLine1: {
        value: this.getPropValue(["data", "address", "line1"]),
        defaultValue: "Adresse ligne 1",
        displayDefault: this.getPropValue(["address", "line1"]).length,
      },
      addressLine2: {
        value: this.getPropValue(["data", "address", "line2"]),
        defaultValue: "Adresse ligne 2",
        displayDefault: this.getPropValue(["address", "line2"]).length,
      },
      addressLine3: {
        value: this.getPropValue(["data", "address", "line3"]),
        defaultValue: "Adresse ligne 3",
        displayDefault: this.getPropValue(["address", "line3"]).length,
      },
      addressPostCode: {
        value: this.getPropValue(["data", "address", "postCode"]),
        defaultValue: "Code postal",
        displayDefault: this.getPropValue(["address", "postCode"]).length,
      },
      addressLocality: {
        value: this.getPropValue(["data", "address", "locality"]),
        defaultValue: "Ville",
        displayDefault: this.getPropValue(["address", "locality"]).length,
      },
    };
  }

  getPropValue = (args) => {
    var previousObj = undefined;
    for (var i = 0; i < args.length; i++) {
      if (null === previousObj || !previousObj) {
        previousObj = this.props[args[i]];
      } else {
        previousObj = previousObj[args[i]];
      }
      if (previousObj === null || previousObj === undefined) {
        return "";
      }
    }

    return previousObj;
  };
  //LifeCycle
  componentWillReceiveProps(nextProps, nextState) {
    if (
      this.props.data !== nextProps.data ||
      this.props.editing !== nextProps.editing
    ) {
      var _state = this.state;
      _state["data"] = nextProps.data;
      _state["originalData"] = nextProps.data;
      _state["editing"] = nextProps.editing;
      _state["label"].value = nextProps.data.label;
      _state["label"].displayDefault =
        getStrValue(nextProps.data.label).length === 0;
      this.setState(_state);
    }
  }
  //Handler
  resetHandler = (event) => {
    event.preventDefault();
    var _originalData = this.state.originalData;
    this.setState({ data: _originalData });
    this.props.disableOthersEditing(null);
  };

  enabledHandler = (event) => {
    event.preventDefault();
    var _data = this.state.data;
    _data.enabled = !_data.enabled;
    this.props.saveOrUpdate(_data);
  };

  saveHandler = (event) => {
    event.preventDefault();
    var _state = this.state;
    _state.data.label = this.state.label.value;
    _state.data.address.line1 = this.state.addressLine1.value;
    _state.data.address.line2 = this.state.addressLine2.value;
    _state.data.address.line3 = this.state.addressLine3.value;
    _state.data.address.postCode = this.state.addressPostCode.value;
    _state.data.address.locality = this.state.addressLocality.value;
    _state.editing = false;
    this.setState(_state);
    let section = _state.data;
    if (section.id == null) {
      section.company = {
        "id": _state.data.company.id,
        "name": _state.data.company.name,
      }
    }
    this.props.saveOrUpdate(section);
  };

  editHandler = (event) => {
    event.preventDefault();
    this.props.disableOthersEditing(this.props.data.id);
  };

  validChangeHandler = () => {
    const { data, label, addressLine1, addressLine2, addressLine3, addressPostCode, addressLocality } = this.state;
    return (
      (label.value !== data.label ||
        addressLine1.value !== data.addressLine1 ||
        addressLine2.value !== data.addressLine2 ||
        addressLine3.value !== data.addressLine3 ||
        addressPostCode.value !== data.addressPostCode ||
        addressLocality.value !== data.addressLocality) &&
      data.company && null !== data.company
    );
  };

  changeInputHandler = (event, obj) => {
    var _state = this.state;
    const stateEventId = event.target.id.substring(0, event.target.id.indexOf("_"));
    //console.log(stateEventId);
    _state[stateEventId].value = event.target.value;
    _state[stateEventId].displayDefault =
      event.target.value.trim().length === 0;
    this.setState(_state);
  };

  changeCompanyHandler = (event) => {
    var _state = this.state;
    var _company = null;
    for (var i = 0; i < this.props.companies.length; i++) {
      if (
        parseInt(this.props.companies[i].id, 10) ===
        parseInt(event.target.value, 10)
      ) {
        _company = this.props.companies[i];
        break;
      }
    }

    _state.data.company = _company;
    this.setState(_state);
  };

  displayDefault = (val) => {
    if (val.displayDefault) {
      return val.defaultValue;
    }
    return val.value;
  };

  getCell = (id, size, editing, obj) => {
    return (<Col sm={size}>
      <input
        type="text"
        id={id}
        placeholder={
          editing ? obj.defaultValue : ""
        }
        className={
          editing ? obj.displayDefault
              ? styles.editableField
              : styles.editableExistField
            : styles.normalField
        }
        disabled={!editing}
        onChange={(event) =>
          this.changeInputHandler(event, obj)
        }
        value={obj.value}
      />
    </Col>)
  }

  conpanySelect = (data, companies) => {
    if (data.id === null) {
      if (isA() || isReporter()) {
        return (<select
          id="company"
          style={{ color: "#000" }}
          onChange={(event) => this.changeCompanyHandler(event)}
        >
          <option value="0">--- Choisir ---</option>
          {companies.filter((c) => c.activated !== false).map((company, index) => {
            return (
              <option key={index} value={company.id}>
                {company.name}
              </option>
            );
          })}
          ;
        </select>);
      } else {
        return companies[0].name;
      }
    } else {
      return data.company;
    }
  }

  displayButton = (editing) => {
    return editing ? (
      <Button
        bsStyle="success"
        bsSize="xsmall"
        disabled={!this.validChangeHandler()}
        onClick={(event) => this.saveHandler(event)}
      >
        <i className="fa fa-check"></i>&nbsp;Valider
      </Button>
    ) : (
      <Button
        bsStyle="info"
        bsSize="xsmall"
        onClick={(event) => this.editHandler(event)}
      >
        <i className="fa fa-edit"></i>&nbsp;&Eacute;diter
      </Button>
    );
  }

  render() {
    const { data } = this.state;
    if (data === null || !data) {
      return null;
    }
    const { label, addressLine1, addressLine2, addressLine3, addressPostCode, addressLocality } = this.state;
    const { editing, companies } = this.props;
    
    return (
      <Panel bsStyle={data.enabled ? "primary" : "danger"}>
        <Panel.Heading
          className="clearfix"
          style={{ padding: "5px", paddingLeft: "10px" }}
        >
          <div className="pull-left">
            {this.conpanySelect(data, companies)}
          </div>
          {editing ? null : (
            <div className="pull-right">
              <i className={ data.enabled ? "fa fa-trash-o" : "fa fa-undo" }
                style={{ cursor: "pointer" }}
                onClick={(event) => this.enabledHandler(event)}
              />
            </div>
          )}
        </Panel.Heading>
        <Panel.Body style={{ paddingTop: "5px" }}>
          <Row>
            <Col sm={1}>
              <i className="fa fa-building"></i>
            </Col>
            {this.getCell("label_" + data.id, 10, editing, label)}
            <Col sm={1}></Col>
          </Row>
          <Row>
            <Col sm={1}>
              <i className="fa fa-address-card"></i>
            </Col>
            {this.getCell("addressLine1_" + data.id, 10, editing, addressLine1)}
            <Col sm={1}></Col>
          </Row>
          <Row>
            <Col sm={1}></Col>
            {this.getCell("addressLine2_" + data.id, 10, editing, addressLine2)}
            <Col sm={1}></Col>
          </Row>
          <Row>
            <Col sm={1}></Col>
            {this.getCell("addressLine3_" + data.id, 10, editing, addressLine3)}
            <Col sm={1}></Col>
          </Row>
          <Row>
            <Col sm={1}></Col>
            {this.getCell("addressPostCode_" + data.id, 5, editing, addressPostCode)}
            {this.getCell("addressLocality_" + data.id, 5, editing, addressLocality)}
            <Col sm={1}></Col>
          </Row>
        </Panel.Body>
        {data.enabled ? (
          <Panel.Footer className="clearfix">
            <div className="pull-left">
              {this.displayButton(editing)}
            </div>
          </Panel.Footer>
        ) : null}
      </Panel>
    );
  }
}

export default Section;



// WEBPACK FOOTER //
// ./src/containers/Section/Section.js